import * as React from "react"
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget, Pair } from "widgets-for-react"
import { CMSState } from "../../../../cms/blocks/types.gen";
import { getClassName } from "../../../../cms/blocks/utils.gen";
import { ParsedParagraphFactsAndFiguresItem } from "../../../../drupal/types_and_parser/types";
import { List } from 'immutable'
import { doBubbles } from "../../../utils/bubbles";

export type text_color = "black" | "white"

export type factsAndFiguresBlockProps = {
  index: number
  facts_and_figures_items: List<ParsedParagraphFactsAndFiguresItem>
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type factsAndFiguresBlockStyle = Partial<{
  //TODO clean up?
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  label_classname: string
  list_classname: string
  item_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  visual_classname: string
  image_classname: string
  clickable_wrapper_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function factsAndFiguresBlock<customBlockData, extra_images>(
  props: factsAndFiguresBlockProps,
  options?: { style?: factsAndFiguresBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, never>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (cmsState: CMSState<customBlockData, extra_images, never>) =>
    mk_widget({
      run: _ => (
        <section
          id={`io-${options && options.key ? options.key : props.index}`}
          className={getClassName(options, "block_fullwidth_classname", "container-fluid bg-light my-5")}
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <InView
            threshold={0.50} 
            triggerOnce={true}
            className={getClassName(options, "inner_classname", `container d-flex`)}
            onChange={(inView, event) => {
              const inner: HTMLElement = event.target as HTMLElement;
              if (!inView || inner === null) {
                return; 
              }
              
              inner.classList.add('bubbles');
              inner.classList.add('bubbles--orange');
              inner.classList.add('bubbles--infinite')
              doBubbles(inner);
            }}
            >
            <div className={getClassName(options, "content_classname", "p-5")}>
              <ul className={getClassName(options, "list_classname", "")}>
              {props.facts_and_figures_items.map(item =>
                <li className={getClassName(options, "item_classname", "")}>
                  <h3 className={getClassName(options, "title_classname", "text-center mb-3")}>{commafy(item.field_number)}</h3>
                  <div className={getClassName(options, "label_classname", "text-center mb-3")}>{item.field_label}</div>
                </li>
              )}
              </ul>
            </div>
          </InView>
        </section>
      ),
    })
}

function commafy(num) {
  var str = num.toString().split('.');
  if (str[0].length >= 4) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  if (str[1] && str[1].length >= 4) {
    str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }
  return str.join('.');
}